import type { FileItem } from '../types';

export function selectSubmittedFile(
  files: FileItem[],
  requestedPath?: string,
): FileItem | undefined {
  return files.find((file) => file.path === requestedPath) ?? files[0];
}
